/**
 * Platform gate for Video AI interviews (must match backend VIDEO_INTERVIEW_ENABLED).
 * Set REACT_APP_VIDEO_INTERVIEW_ENABLED=true when enabling video interviews.
 */
export const VIDEO_INTERVIEW_FEATURE_ENABLED =
  String(process.env.REACT_APP_VIDEO_INTERVIEW_ENABLED || "false")
    .trim()
    .toLowerCase() === "true";
